import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, FormControl } from 'react-bootstrap';

import AuthContext from '../../authentication/AuthContext';
import UserContext from '../../user/UserContext';
import axios from 'axios';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { useAlert } from 'react-alert';
import { useHistory } from 'react-router-dom';
import LoadingSpinner from '../../common/LoadingSpinner';
import Papa from 'papaparse';
import { IconWrapper } from '../../common/IconWrapper';
import SupplierMinimumOrderQuantity from './SupplierMinimumOrderQuantity';

export default function CreateOrder() {
    const [loading, setLoading] = useState(true);
    const [suppliers, setSuppliers] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState('');
    const [orderRef, setOrderRef] = useState('');

    const history = useHistory();

    const cas = useContext(AuthContext);

    const { userDetails } = useContext(UserContext);

    const alert = useAlert();

    const fileInputRef = useRef();

    const productCodeRegex = new RegExp(/^\s*\d+\s*$/);
    const numberRegex = new RegExp(/^\s*[-+]?\d*\s*$/);

    const [moqDetail, setMoqDetail] = useState();

    const IMPORT_ORDER_GROUP_NAME = 'Wholesale Import Order Control Group';

    useEffect(() => {
        if (userDetails.currentFranchise) {
            axios
                .get(window.CONFIG['ws.activoc-static-data-api.suppliers'], {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json'
                    },
                    params: {
                        franchiseCode: userDetails.currentFranchise.code
                    }
                })
                .then(response => {
                    let json = response.data;
                    setSuppliers(json);
                    setLoading(false);
                });
            const moqUrl =
                window.CONFIG['ws.activoc-web-order-api.moq.progress'] +
                '?franchiseCode=' +
                userDetails.currentFranchise.code;
            axios
                .get(moqUrl, {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    setMoqDetail(response.data);
                })
                .catch(() => {
                    alert.error('Unable to retrieve MOQ progress');
                });
        }
        // eslint-disable-next-line
    }, [cas, userDetails]);

    const handleClose = () => {
        setSelectedSupplier('');
        setOrderRef('');
        history.goBack();
    };

    const handleSubmit = () => {
        let requestBody = {
            originatingSystem: 'ActivOC',
            isContent: false,
            franchiseCode: userDetails.currentFranchise.code,
            supplierCode: selectedSupplier,
            retailerReference: orderRef
        };
        axios
            .post(window.CONFIG['ws.activoc-web-order-api.orders'], requestBody, {
                headers: {
                    Authorization: cas,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                let createdOrderId = response.data.id;
                alert.success('Order: ' + createdOrderId + ' successfully created');
                history.push('/order/' + createdOrderId);
            })
            .catch(() => {
                alert.error('Unable to create order, please try again');
            });
    };

    const importFile = files => {
        const errorMessage = getFileErrors(files);
        if (errorMessage) {
            alert.error('ERROR: ' + errorMessage);
            return;
        }
        let productList = [];
        Papa.parse(files[0], {
            delimiter: ',',
            complete: result => {
                /* istanbul ignore if */
                if (result.errors.length > 0) {
                    result.errors.forEach(error => {
                        alert.error('ERROR: ' + error.message);
                    });
                } else {
                    result.data.forEach(item => {
                        if (
                            item.length === 2 &&
                            item[0].length > 0 &&
                            item[1].length > 0 &&
                            productCodeRegex.test(item[0]) &&
                            numberRegex.test(item[1])
                        ) {
                            productList.push({
                                productCode: item[0],
                                quantity: item[1]
                            });
                        }
                    });
                    if (productList.length === 0) {
                        alert.error('ERROR: No lines found to import');
                        return;
                    }
                    axios
                        .post(
                            window.CONFIG['ws.activoc-web-order-api.orders.import'],
                            {
                                products: productList,
                                franchiseCode: userDetails.currentFranchise.code,
                                supplierCode: selectedSupplier,
                                retailerReference: orderRef
                            },
                            {
                                headers: {
                                    Authorization: cas,
                                    'Content-Type': 'application/json'
                                }
                            }
                        )
                        .then(response => {
                            let createdOrderId = response.data.id;
                            alert.success('Order: ' + createdOrderId + ' successfully imported');
                            history.push('/order/' + createdOrderId);
                        })
                        .catch(() => {
                            alert.error('ERROR: Unable to import order, please try again');
                        });
                }
            }
        });
    };

    return (
        <div>
            <div className={'page-header'}>
                <div className={'content'}>
                    <div className={'page-header-container flex'}>
                        <h1>Create Order</h1>
                    </div>
                </div>
            </div>
            <div className={'content'}>
                <div id={'create-order-wrapper'}>
                    <div className={'create-order-form'}>
                        {loading ? (
                            <LoadingSpinner />
                        ) : (
                            <FormControl
                                as="select"
                                value={selectedSupplier}
                                onChange={e => setSelectedSupplier(e.target.value)}
                            >
                                <option disabled={true} value={''}>
                                    Choose a supplier type...
                                </option>
                                {suppliers.map(supplier => (
                                    <option value={supplier.code} key={supplier.code}>
                                        {supplier.name}
                                    </option>
                                ))}
                            </FormControl>
                        )}
                        <FormControl
                            type={'text'}
                            placeholder={'Give your order a name (optional)'}
                            value={orderRef}
                            onChange={e => setOrderRef(e.target.value)}
                            maxLength={45}
                        />
                        <span className={'character-count'}>
                            {orderRef === ''
                                ? 'Max 45 characters'
                                : 45 - orderRef.length + ' characters remaining'}
                        </span>
                        <div className={'create-buttons flex'}>
                            <Button variant={'secondary'} onClick={handleClose}>
                                <IconWrapper icon={faTimesCircle} />
                                Cancel
                            </Button>
                            {(userDetails.telesales ||
                                userDetails?.currentFranchise?.controlGroups.includes(
                                    IMPORT_ORDER_GROUP_NAME
                                )) && (
                                <>
                                    <Button
                                        variant={'primary'}
                                        disabled={selectedSupplier === ''}
                                        onClick={() => {
                                            fileInputRef.current.click();
                                        }}
                                    >
                                        Import Order
                                    </Button>
                                    <input
                                        id={'import-file-input'}
                                        data-testid={'import-file-input'}
                                        type={'file'}
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                        onChange={e => {
                                            e.preventDefault();
                                            importFile(e.target.files);
                                        }}
                                        accept={'.csv'}
                                    />
                                </>
                            )}
                            <Button
                                variant={'primary'}
                                className={'btn-action'}
                                disabled={selectedSupplier === ''}
                                onClick={handleSubmit}
                            >
                                Create Order
                            </Button>
                        </div>
                        {selectedSupplier && moqDetail && (
                            <SupplierMinimumOrderQuantity
                                singleMoq={
                                    selectedSupplier === 'NISA' ? moqDetail.ambient : moqDetail.chillfreeze
                                }
                                division={selectedSupplier === 'NISA' ? 'Ambient' : 'Chill and Freeze'}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

function getFileErrors(fileList) {
    if (fileList.length === 0) {
        return 'No file selected';
    }
    const file = fileList[0];
    if (!validFileType(file.type)) {
        return 'File type is not csv';
    }
    if (file.size === 0) {
        return 'File is empty';
    }
    return false;
}

function validFileType(type) {
    var fileTypes = ['text/csv', 'application/vnd.ms-excel'];

    for (var i = 0; i < fileTypes.length; i++) {
        if (type === fileTypes[i]) {
            return true;
        }
    }

    return false;
}
